import React, { useState, useEffect } from 'react';
import {Row, Col} from 'react-bootstrap';
import BookCover from "./BookCover";

function ProjectList() {
    const [projects, setProjects] = useState([]);
    let p;

    const fetchProjects = async () => {
        {(localStorage.getItem("mau_user_type") == "admin" || localStorage.getItem("mau_user_type") == "dev") ? (
            p = 1
        ) : (
            p = 0
        )}
        fetch('https://api.lexikonn.eu/mau/getbooks.php?l=0&p='+p)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                console.log('Data received:', data);
                setProjects(data);
            })
            .catch(error => console.error('Chyba při načítání dat:', error));
    };

    useEffect(() => {
        fetchProjects();
    }, []);

    return (
        <div>
            <Row className="d-flex justify-content-center align-items-center">
                {
                    projects ? projects.map(project => (
                        <BookCover title={project.title} publicBook={project.public} img={project.image} chapters={project.all_chapters} id={project.id}/>
                    )) : "Nic nenalezeno"
                }
            </Row>
        </div>
    );
}

export default ProjectList;
